import styled from 'styled-components';
import { COLORS, FONT_FAMILY, FONTS } from 'utils/styles';

export const CloseIcon = styled.img`
  position: absolute;
  top: 22px;
  right: 22px;
  cursor: pointer;
`;

export const DeleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
`;

export const AreYouSureDelete = styled.span`
  height: 20px;
  color: ${COLORS.lightSilver};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
`;

export const ItemBoldText = styled.span`
  height: 20px;
  color: ${COLORS.lightSilver};
  ${FONTS.font16};
  ${FONT_FAMILY.FontBold};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
  width: 366px;
  height: 46px;
`;

export const ButtonCancelAndDelete = styled.button`
  width: 172px;
  height: 46px;
  background: ${({ isCancel }) => (isCancel ? 'transparent' : COLORS.mainColor)};
  color: ${({ isCancel }) => (isCancel ? COLORS.mainColor : COLORS.white)};
  border: 1px solid ${COLORS.mainColor};
  border-radius: 8px;
  ${FONTS.font16};

  &:hover {
    background: ${({ isCancel }) => (isCancel ? COLORS.mainColor : 'transparent')};
    color: ${({ isCancel }) => (isCancel ? COLORS.white : COLORS.mainColor)};
    transition: 1s;
  }
`;
